import { render, staticRenderFns } from "./login.vue?vue&type=template&id=6289a1fa&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginSavedMethod: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/login/loginSavedMethod.vue').default,LoginButton: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/login/loginButton.vue').default,LoginCard: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/login/loginCard.vue').default,LoginOneTimeLinkNotification: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/login/loginOneTimeLinkNotification.vue').default,I18n: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/i18n.vue').default,LoginForm: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/login/LoginForm.vue').default})
